// The floating toolbar's decisions (Lexical `FloatingToolbarPlugin`): which format toggles exist, their intents and
// pressed bits, and when the toolbar shows. Hosts own icons, geometry and portals.
import { FormatFlag } from '@w/content-blocks/src/block'
import { selectedLink } from './rich-content'
import type { CoreState } from './state'

export const formatToggles = [
  { title: 'Bold', intent: { type: 'formatBold' }, flag: FormatFlag.BOLD },
  { title: 'Italic', intent: { type: 'formatItalic' }, flag: FormatFlag.ITALIC },
  { title: 'Underline', intent: { type: 'formatUnderline' }, flag: FormatFlag.UNDERLINE },
  { title: 'Strikethrough', intent: { type: 'formatStrikeThrough' }, flag: FormatFlag.STRIKE },
] as const

/** Shown for a table selection, a text range, or a caret inside a link. */
export function formatToolbarVisible(state: CoreState): boolean {
  const selection = state.selection
  if (!selection || selection.nodes?.length) return false
  const caret = !selection.table && selection.anchor.blockId === selection.focus.blockId && selection.anchor.offset === selection.focus.offset
  return !caret || selectedLink(state) !== null
}
